const React = require("react");

export const marqueeTexts = [
	[
		<span>
			NOW <br />
			SHOWING
		</span>,
		<span>
			BEAST <br />
			AND <br />
			THE BEAUTY
		</span>,
	],
	[
		<span>
			3D <br />
			GLASSES
		</span>,
		<span>
			UP TO <br />
			EIGHT EYES!
		</span>,
	],
	[
		<span>HOW TO TRAIN YOUR SAPIEN</span>,
		<span>
			12:30 3:00 <br />
			5:30 8:15
		</span>,
	],
	[<span>POPCORN INCIDENT</span>, <span>BACK ROW TEMPORARILY CLOSED</span>],
	[<span>THIS WEEK ONLY</span>, <span>2+ HEADS= 1&nbsp;TICKET!</span>],
	[
		<span>TONIGHT! HAMLET</span>,
		<span>
			FEATURING <br />
			R&amp;G!
		</span>,
	],
	[
		<span>
			FREE <br />
			SODA!
		</span>,
		<span>
			WITH PURCHASE <br /> OF $5 STRAW
		</span>,
	],
	[
		<span>1/2 PRICED TICKETS!</span>,
		<span>FOR BEASTS UNDER 10 INCHES TALL</span>,
	],
	[
		<span>SHOES REQUIRED</span>,
		<span>
			IF YOU <br />
			HAVE FEET
		</span>,
	],
	[<span>SLIME MONSTERS WELCOME</span>, <span>TUB SEATING AVAILABLE</span>],
	[
		<span>YETI TRILOGY</span>,
		<span>THE YETI YETI&nbsp;RETURNS YETI AGAIN</span>,
	],
	[
		<span>
			GREMLINS <br /> EAT FREE
		</span>,
		<span>TUESDAYS BEFORE MIDNIGHT</span>,
	],
	[
		<span>
			ONE TICKET <br /> PER HEAD
		</span>,
		<span>
			NO <br />
			EXCEPTIONS
		</span>,
	],
	[
		<span>
			FLOOR <br />
			<span style={{color: "red", fontSize: "1.2em"}}>SOLD OUT</span>
		</span>,
		<span>FLYING ROOM ONLY</span>,
	],
	[
		<span>
			THIS <br />
			WEEK <br /> ONLY!
		</span>,
		<span>
			KRAKEN <br />
			ON <br /> BANJO
		</span>,
	],
	[
		<span>WHY DID THE DRAGON CROSS THE ROAD?</span>,
		<span>TO SIT IN OUR PLUSH THEATER SEATS!</span>,
	],
	[
		<span>
			THIS SIGN WRITTEN BY <br />
			AN INFINITE
		</span>,
		<span>
			NUMBER <br />
			OF TYPING CHIMPANDAS
		</span>,
	],
	[
		<span>THIS SIGN IS TOO SMALL TO CONTAIN MY</span>,
		<span>MARVELOUS PROOF. P.&nbsp;FERMAT</span>,
	],
	[
		<span>DRAGONS: BRING YOUR OWN KERNELS</span>,
		<span>PLEASE POP OUTSIDE THEATER.</span>,
	],
	[
		<span>LIMITED OFFER, 1 FREE TICKET</span>,
		<span>WHEN YOU BUY 1 TICKET AT DOUBLE PRICE.</span>,
	],
	[
		<span>
			<span style={{color: "red", fontSize: "1.2em"}}>NEW SHOW!</span>{" "}
			DISAPPEARING DAVE
		</span>,
		<span>
			NOT <br />
			APPEARING TONIGHT
		</span>,
	],
	[
		<span>
			PIRATES <br /> OF <br />
			BEAST&nbsp;BAY
		</span>,
		<span>
			RATED <br />
			ARRRRR!
		</span>,
	],
	[<span>MISSING (AGAIN)</span>, <span>PROFESSOR GROK</span>],
	[<span>CAPT. KRAKEN PRESENTS</span>, <span>FINDING MR.&nbsp;WRIGGLES</span>],
	[
		<span>COMEDY SPECIAL</span>,
		<span>
			SON
			<br /> OF
			<br /> GODZILLA
		</span>,
	],
];
